module.exports = __webpack_public_path__ + "img/ai.f00945e.svg";